export const iconFontAwesomeGamingDiceSix = (
	<i className="fa-solid fa-dice-six"></i>
);
